import type { VoidFunctionComponent } from 'react'

import { ModalBody, useModal } from '@monthio/react-components'
import { useEffect } from 'react'
import { Translation, useTranslation } from 'react-i18next'

const ConsumerInputErrorBody = () => (
	<Translation>
		{(t) => {
			return (
				<ModalBody>
					<p>{t('consumerInput-validationError-description')}</p>
				</ModalBody>
			)
		}}
	</Translation>
)

interface ConsumerInputErrorProps {
	isFailure: boolean
}

export const ConsumerInputError: VoidFunctionComponent<
	ConsumerInputErrorProps
> = ({ isFailure }: ConsumerInputErrorProps) => {
	const { openModal } = useModal()
	const { t } = useTranslation()

	useEffect(() => {
		if (isFailure) {
			// Modal needs to show up before we can find it

			openModal({
				title: t('consumerInput-validationError-title'),
				responsive: false,
				bodyRender: ConsumerInputErrorBody,
			})
		}
	}, [isFailure])

	return null
}
